import { memo } from 'react';

import type { ContentBlock } from '@/types/newsService';

interface Props {
  block: ContentBlock;
}

export const QuoteBlock = memo(function QuoteBlock({ block }: Props) {
  if (!block.text) return null;

  return (
    <blockquote className="my-3 border-l-4 border-brand py-2 pl-4">
      <p className="whitespace-pre-line text-base italic leading-6 text-fg">{block.text}</p>
      {block.attribution ? (
        <cite className="mt-2 block text-[13px] not-italic text-fg-muted">
          — {block.attribution}
        </cite>
      ) : null}
    </blockquote>
  );
});
